import { Input } from '@patrianna/core-components'
import * as React from 'react'

export type NotOverridableProps =
  | 'openPicker'
  | 'inputValue'
  | 'onChange'
  | 'format'
  | 'validationError'
  | 'format'
  | 'forwardedRef'

export type PureDateInputProps = {
  inputValue: string
  validationError?: React.ReactNode
  openPicker: () => void
  dataTestId?: string
}

export const PureDateInput = ({ inputValue, validationError, openPicker: onOpen, ...other }: PureDateInputProps) => {
  return (
    <Input
      error={Boolean(validationError)}
      helperText={validationError}
      {...other}
      // do not overridable
      onClick={onOpen}
      value={inputValue}
      onKeyDown={(e) => {
        // space
        if (e.keyCode === 32) {
          e.stopPropagation()
          onOpen()
        }
      }}
      dataTestId={other.dataTestId || 'date-input'}
    />
  )
}
